import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { AppConfig } from '../../../app.config';

@Injectable()
export class MesCollectivitesService {
    private urlGetCollectivitesDetails: string = '';

    constructor(private http: HttpClient, private _appConfig: AppConfig) {
        this.urlGetCollectivitesDetails = _appConfig.getConfig().nPointDeclarations + '/decla-traitement/GetCollectivitesDetails';
    }

    getCollectivitesDetails() {
        return this.http.get(this.urlGetCollectivitesDetails)
            .catch(this.handleError);
    }

    private handleError(err: HttpErrorResponse) {
        console.log(err);
        let errMsg: string;
        if (err && (err.error instanceof Error)) {
            errMsg = `${err.status} - ${err.statusText || ''} ${err}`;
        } else if (err && err.error) {
            errMsg = (err.error.message ? err.error.message : err.error.toString());
        } else if (typeof err == 'string') {
            errMsg = err;
        }

        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/in/mes-collectivites/services/mes-collectivites.service.ts